export function todayParis(now = new Date()) {
  return new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Paris" }).format(
    now,
  );
}
export function formatDate(date) {
  return date ? date.split("-").reverse().join("/") : "Non renseigné";
}
const iso = (date) => date.toISOString().slice(0, 10);
function holidays(year) {
  const a = year % 19,
    b = Math.floor(year / 100),
    c = year % 100,
    d = Math.floor(b / 4),
    e = b % 4,
    f = Math.floor((b + 8) / 25),
    g = Math.floor((b - f + 1) / 3),
    h = (19 * a + b - d - g + 15) % 30,
    i = Math.floor(c / 4),
    k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7,
    m = Math.floor((a + 11 * h + 22 * l) / 451);
  const easter = new Date(
    Date.UTC(
      year,
      Math.floor((h + l - 7 * m + 114) / 31) - 1,
      ((h + l - 7 * m + 114) % 31) + 1,
    ),
  );
  const dates = [
    "01-01",
    "05-01",
    "05-08",
    "07-14",
    "08-15",
    "11-01",
    "11-11",
    "12-25",
  ].map((day) => `${year}-${day}`);
  for (const offset of [1, 39, 50]) {
    const date = new Date(easter);
    date.setUTCDate(date.getUTCDate() + offset);
    dates.push(iso(date));
  }
  return new Set(dates);
}
export function isBusinessDay(value, closures = []) {
  if (!dateValue(value)) return false;
  const date = new Date(`${value}T12:00:00Z`);
  return (
    ![0, 6].includes(date.getUTCDay()) &&
    !holidays(date.getUTCFullYear()).has(value) &&
    !closures.includes(value)
  );
}
export function addBusinessDays(value, count, closures = []) {
  if (!dateValue(value) || !Number.isInteger(count) || count < 0)
    throw new Error("Date ou délai invalide.");
  const date = new Date(`${value}T12:00:00Z`);
  for (let remaining = count; remaining > 0;) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (isBusinessDay(iso(date), closures)) remaining--;
  }
  while (!isBusinessDay(iso(date), closures))
    date.setUTCDate(date.getUTCDate() + 1);
  return iso(date);
}

export function businessDaysBetween(start, end, closures = []) {
  if (!start || !end || start >= end) return 0;
  let count = 0,
    date = new Date(`${start}T12:00:00Z`);
  while (date.toISOString().slice(0, 10) < end) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (isBusinessDay(date.toISOString().slice(0, 10), closures)) count++;
  }
  return count;
}
export function dateValue(value) {
  if (value instanceof Date) return value.toISOString().slice(0, 10);
  const text = String(value || "").trim();
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(text))
    return dateValue(text.split("/").reverse().join("-"));
  if (
    /^\d{4}-\d{2}-\d{2}$/.test(text) &&
    !Number.isNaN(Date.parse(text + "T12:00:00Z")) &&
    new Date(text + "T12:00:00Z").toISOString().slice(0, 10) === text
  )
    return text;
  return "";
}
export function quoteValidityDate(now = new Date()) {
  const [year, month, day] = todayParis(now).split("-").map(Number);
  const target = new Date(Date.UTC(year, month - 1 + 3, 1));
  const lastDay = new Date(
    Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0),
  ).getUTCDate();
  target.setUTCDate(Math.min(day, lastDay));
  return target.toISOString().slice(0, 10);
}
export function reportingPeriod(kind, anchor = todayParis()) {
  const date = new Date(`${anchor}T12:00:00Z`);
  const start = new Date(date),
    end = new Date(date);
  if (kind === "week") {
    start.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
    end.setTime(start.getTime());
    end.setUTCDate(start.getUTCDate() + 6);
  } else if (kind === "month") {
    start.setUTCDate(1);
    end.setUTCMonth(date.getUTCMonth() + 1, 0);
  } else if (kind === "year") {
    start.setUTCMonth(0, 1);
    end.setUTCMonth(11, 31);
  }
  return {
    from: start.toISOString().slice(0, 10),
    to: end.toISOString().slice(0, 10),
  };
}
export function shiftMonth(month, offset) {
  const [year, index] = month.split("-").map(Number);
  return new Date(Date.UTC(year, index - 1 + offset, 1, 12))
    .toISOString()
    .slice(0, 7);
}
export function monthGrid(month) {
  const first = new Date(`${month}-01T12:00:00Z`);
  const offset = (first.getUTCDay() + 6) % 7;
  const last = new Date(
    Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0, 12),
  );
  const count = Math.ceil((offset + last.getUTCDate()) / 7) * 7;
  return Array.from({ length: count }, (_, i) => {
    const day = new Date(first);
    day.setUTCDate(1 - offset + i);
    return day.toISOString().slice(0, 10);
  });
}
